module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiCn.f3373d2.woff";